import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { FileText, Lock } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ReadingPage = () => {
  const [searchParams] = useSearchParams();
  const [readings, setReadings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedLevel, setSelectedLevel] = useState('A1');
  const { user } = useAuth();

  const levels = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'];

  useEffect(() => {
    fetchReadings();
  }, [selectedLevel]);

  const fetchReadings = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/reading?level=${selectedLevel}`);
      if (response.ok) {
        const data = await response.json();
        setReadings(data);
      }
    } catch (error) {
      console.error('Failed to fetch readings:', error);
    } finally {
      setLoading(false);
    }
  };

  const isPremium = user?.subscription_status === 'premium';

  return (
    <div className="min-h-screen bg-gradient-to-b from-babyblue-50 via-babyblue-100/50 to-white flex flex-col">
      <Navbar />

      <main className="flex-1 py-8 px-6">
        <div className="container mx-auto">
          <div className="mb-8 text-center">
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-babyblue-800 mb-2">Reading Exercises</h1>
            <p className="text-babyblue-600">Improve your German reading comprehension</p>
          </div>

          <div className="mb-6">
            <div className="flex flex-wrap gap-3 justify-center">
              {levels.map((level) => (
                <button
                  key={level}
                  onClick={() => setSelectedLevel(level)}
                  className={`px-6 py-2 rounded-full font-medium transition-all ${
                    selectedLevel === level
                      ? 'bg-primary text-white shadow-lg shadow-primary/50'
                      : 'bg-white text-babyblue-600 hover:bg-white border border-primary/30'
                  }`}
                >
                  {level}
                </button>
              ))}
            </div>
          </div>

          {loading ? (
            <div className="flex justify-center py-12">
              <div className="spinner"></div>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {readings.map((reading) => (
                <Link
                  key={reading.reading_id}
                  to={`/reading/${reading.reading_id}`}
                  className="card p-6 hover:shadow-2xl hover:shadow-primary/30 transition-all hover:scale-[1.02]"
                >
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex items-center gap-2">
                      <FileText className="w-5 h-5 text-primary" />
                      <span className="bg-primary/20 text-primary px-3 py-1 rounded-full text-sm font-medium">{reading.level}</span>
                    </div>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-babyblue-800 mb-2">{reading.title}</h3>
                  <p className="text-sm text-babyblue-500 leading-relaxed">{reading.text.substring(0, 150)}...</p>
                  <p className="text-xs text-babyblue-500 mt-3">{reading.questions?.length || 0} questions</p>
                </Link>
              ))}
            </div>
          )}

          {/* Ad Revenue Space */}
          <div className="ad-container mt-8" data-testid="ad-placeholder">
            <p>Advertisement Space</p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ReadingPage;
